<div [innerHTML]="randomIcon"></div>
